import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  BundleDetailsCardContainerStyled as BundleDetailsCardContainer,
  BundleDetailsCardTitleStyled as BundleDetailsCardTitle,
  BundleDetailsCardPromoStyled as BundleDetailsCardPromo,
  BundleDetailsCheckIconStyled as BundleDetailsCheckIcon,
  BundleDetailsModalWrapperStyled as BundleDetailsModalWrapper,
  BundleDetailsModalCardStyled as BundleDetailsModalCard,
  BundleDetailsModalCardTitleStyled as BundleDetailsModalCardTitle,
  BundleDetailsModalCardContentStyled as BundleDetailsModalCardContent,
  BundleDetailsModalCardButtonsStyled as BundleDetailsModalCardButtons,
  OverlayStyled,
} from './styles/BundleDetailsTabContentStyled';
import icoExtraSaldo from '../../../../images/extra-saldo/ico_extra_saldo_mini.svg';
import icoExtraDatos from '../../../../images/extra-saldo/ico_datos.svg';
import icoExtraMinutos from '../../../../images/extra-saldo/ico_phone.svg';
import icoCheckGrey from '../../../../images/extra-saldo/ico_check_grey.svg';
import icoCheckPink from '../../../../images/extra-saldo/ico_check_pink.svg';
import { GoogleTagManager, Numbers, Strings } from '../../../../helpers';
import Button from '../../../General/Button';

const icons = {
  SALDO: icoExtraSaldo,
  DATOS: icoExtraDatos,
  MINUTOS: icoExtraMinutos,
};

const BundleDetailsCard = ({
  offer,
  label,
  index,
  open,
  setOpen,
  setOffer,
}) => {
  const [quantityLabel, setQuantityLabel] = useState('');

  useEffect(() => {
    if (offer.category === 'balance') {
      const quantity = Numbers.addThousandSeparators(offer.quantity);
      setQuantityLabel(`${offer.unity}${quantity}`);
    } else if (offer.category === 'data') {
      setQuantityLabel(`${Math.floor(offer.quantity)} ${offer.unity}`);
    } else {
      setQuantityLabel(`${offer.quantity} ${offer.unity}`);
    }
  }, [offer]);

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: `/tienda/extra-saldo/${Strings.strToUrl(label)}/confirmar`,
      pagename: `Tienda - Extra Saldo - ${Strings.strFirstCaseUpper(
        label
      )}/confirmar`,
    });
  }, [open]);

  const cardClicked = () => {
    setOpen(index);
  };

  const price = Numbers.addThousandSeparators(offer.cost);

  return (
    <>
      <BundleDetailsCardContainer
        key={offer.code}
        onClick={cardClicked}
        data-testid={`bundle-card-${offer.code}`}
      >
        <BundleDetailsCardTitle>
          <img src={icons[label]} alt={label} />
          <p>{label}</p>
        </BundleDetailsCardTitle>
        <BundleDetailsCardPromo>
          {offer.category !== 'balance' ? <h5>{`$${price}`}</h5> : null}
          <h2>{quantityLabel}</h2>
          <h4>{`X${offer.validity} días`}</h4>
          <BundleDetailsCheckIcon>
            <img src={open ? icoCheckPink : icoCheckGrey} alt={offer.code} />
          </BundleDetailsCheckIcon>
        </BundleDetailsCardPromo>
      </BundleDetailsCardContainer>
      {open && (
        <>
          <BundleDetailsModalWrapper>
            <BundleDetailsModalCard>
              <BundleDetailsModalCardTitle>
                Estás pidiendo un <strong>Extra Saldo</strong> de
              </BundleDetailsModalCardTitle>
              <BundleDetailsModalCardContent>
                <h2>{quantityLabel}</h2>
                <p>
                  {`válido por `}
                  <strong>
                    <strong>{offer.validity}</strong>{' '}
                    {offer.validity === 1 ? 'día' : 'días'}
                  </strong>
                </p>
                <p>
                  Se descontarán{' '}
                  <strong>${offer.cost + offer.commission}</strong> de tu
                  próxima recarga
                </p>
              </BundleDetailsModalCardContent>

              <BundleDetailsModalCardButtons>
                <Button outline maxWidth="180px" click={() => setOpen(!open)}>
                  Cancelar
                </Button>
                <Button
                  color="bubbleGum"
                  maxWidth="180px"
                  click={() => setOffer(offer)}
                >
                  Confirmar
                </Button>
              </BundleDetailsModalCardButtons>
            </BundleDetailsModalCard>
          </BundleDetailsModalWrapper>
          <OverlayStyled onClick={() => setOpen(!open)}> </OverlayStyled>
        </>
      )}
    </>
  );
};

BundleDetailsCard.propTypes = {
  offer: PropTypes.shape({
    category: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    commission: PropTypes.number.isRequired,
    cost: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    unity: PropTypes.string.isRequired,
    validity: PropTypes.number.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setOffer: PropTypes.func.isRequired,
};

export default BundleDetailsCard;
